import React from 'react'
import PropTypes from 'prop-types'

import { Table } from '../../..'
import tableDisplay from './Layers.table'
import LayersListTitle from './LayersListTitle'
import { withTranslation } from 'react-i18next'
import { usePageTitle } from '../../../../actions/app'

const Layers = ({
    data,
    nextPage,
    onClickUpload,
    onClickUrl,
    children,
    bulkSelectionLayers,
    bulkSelectionAllLayers,
    selectedAll,
    onDeleteLayer,
    resetSelection,
    t,
}) => {
    usePageTitle(t('Layers'))

    async function onClickDelete() {
        try {
            await Promise.all(
                data?.map(async ({ id, selected }, index) => {
                    setTimeout(async () => {
                        if (id && selected) {
                            onDeleteLayer(id)
                        }
                    }, index * 1000)
                })
            )
            resetSelection()
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <Table
            data={data}
            display={tableDisplay({ onClickUrl, bulkSelectionLayers, bulkSelectionAllLayers, selectedAll, onDeleteLayer, t })}
            fieldsNotToSort={['offline']}
            keyField="id"
            nextPage={nextPage}
            sortable
            autoscroll
            // title="Layers"
        >
            {
                <LayersListTitle onClickUpload={onClickUpload} onClickDelete={onClickDelete}>
                    {children}
                </LayersListTitle>
            }
        </Table>
    )
}

Layers.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            offline: PropTypes.bool,
            portrait: PropTypes.bool,
            landscape: PropTypes.bool,
        })
    ),
    nextPage: PropTypes.func,
    onChangeSearch: PropTypes.func,
    onClickUpload: PropTypes.func,
    onClickUrl: PropTypes.func,
    valueSearch: PropTypes.string,
    children: PropTypes.node,
}

Layers.defaultProps = {
    data: [],
    nextPage: null,
    onChangeSearch: () => null,
    onClickUpload: () => null,
    onClickUrl: () => null,
    valueSearch: '',
}

export default withTranslation()(Layers)
